import { atom } from 'recoil';

const calculatorIdState = atom({
  key: 'calculatorIdState',
  default: undefined,
});

export default calculatorIdState;
